module.exports = __webpack_public_path__ + "static/Raleway-Regular.580d0778.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/fonts/Raleway/Raleway-Regular.ttf
// module id = 144
// module chunks = 4